export default __webpack_public_path__ + "static/media/full.3a688374.jpg";